module.exports = __webpack_public_path__ + "img/DE00204.f7b890e8.png";